// bundle-builder.js
export default (Alpine) => {
    Alpine.data("bundleBuilder", () => ({
      activeCollection: window.activeCollection,
      sectionedBoxId: "9918606475584",
      boxData: {},
      products: {},
      loading: false,
      loaded: false,
      error: null,
      items: [],
      steps: [],
      // --- helpers ---
      bundle: {},
      selectedByPid: {},
      minQty: 0,
      maxQty: 0,
      totalSelectedQty: 0,
      placeHolders: [],
      selectedVariant: '',
      sellingPlans: [],
      sellingPlan: '',
      purchaseOption: 'subscribe',
      discountTiers: [],
      discountTier: 0,
      bundleOpen: false,
      adding: false,
      jsLoaded: false,
      buttonText: 'Add two or more products',
      buttonDisabled: true,
      sellingPlanName: 'Select Frequency',
      
      get selectedVariantId() {
        return this.$el.closest('[data-product]').dataset.selectedVariantId;
      },

      get isInBundle() {
        const productEl = this.$el.closest('[data-product]');
        const vid = productEl.dataset.selectedVariantId;
        const isInBundle = this.bundle[vid] ? true : false;
        return isInBundle;
      },

      get bundleList() {
        // deterministic order to avoid render churn
        return Object.entries(this.bundle)
          .sort(([a],[b]) => a.localeCompare(b))
          .map(([vid, item]) => ({ ...item, vid }));
      },
      
      get bundleItemPrice() {
        const productId = this.idTail(this.$el.closest('[data-bundle-item]').dataset.productId);
        const variantId = this.idTail(this.$el.closest('[data-bundle-item]').dataset.variantId);
        const variant = this.findVariantById(productId, variantId);

        if (!variant) return;
        const quantity = this.bundle[variantId]?.qty;

        this.discountTier = this.getdiscountTier();

        const variantPriceTierDiscount = variant.price * (1 - this.discountTier / 100) * quantity;

        const variantPrice = this.purchaseOption === 'one-time'
          ? variantPriceTierDiscount
          : this.calculateSubscriptionPrice(variantPriceTierDiscount)
        return this.formatMoney(variantPrice);
      },

      get bundleItemOriginalPrice() {
        const productId = this.idTail(this.$el.closest('[data-bundle-item]').dataset.productId);
        const variantId = this.idTail(this.$el.closest('[data-bundle-item]').dataset.variantId);
        const variant = this.findVariantById(productId, variantId);
        if (!variant) return;
        const quantity = this.bundle[variantId]?.qty;
        const originalPrice = variant.price * quantity;
        return this.formatMoney(originalPrice);
      },

      get productPrice() {
        const productEl = this?.$el.closest('[data-product]');
        const productId = this?.idTail(productEl.dataset.productId);
        const variantId = this?.idTail(productEl.dataset.selectedVariantId);

        if (!productId || !variantId) return null;

        const variant = this?.findVariantById(productId, variantId);

        if (!variant || !variant.price) return null;
        const price = this?.purchaseOption === 'one-time' ? variant.price : this?.calculateSubscriptionPrice(variant.price);

        return this.formatMoney(price);
      },

      getdiscountTier() {
        const tiers = this.discountTiers;

        if (this.totalSelectedQty < this.minQty) {
          return this.discountTier = 0;
        } else if (this.totalSelectedQty >= this.maxQty) {
          return this.discountTier = tiers[this.maxQty-1];
        } else {
          return this.discountTier = tiers[this.totalSelectedQty];
        }
      },

      get totalPrice() {
        const totalPrice = Object.values(this.bundle).reduce((acc, item) => acc + item.originalPrice * item.qty, 0)
        return totalPrice
      },

      get totalNewPriceOneTime() {
        const discountTier = this.getdiscountTier();
        const totalPriceWithDiscount = this.totalPrice * (1 - discountTier / 100)
        return this.formatMoney(totalPriceWithDiscount);
      },

      get totalNewPriceSubscribe() {
        const discountTier = this.getdiscountTier();
        const variantPriceTierDiscount = this.totalPrice * (1 - discountTier / 100)
        const totalPriceWithDiscount = this.calculateSubscriptionPrice(variantPriceTierDiscount)
        return totalPriceWithDiscount;
      },

      get totalOriginalPrice() {
        const originalPrice = Object.values(this.bundle).reduce((acc, item) => acc + item.originalPrice * item.qty, 0)
        return this.formatMoney(originalPrice);
      },

      get totalFinalPrice() {
        const totalPriceWithDiscount = this.purchaseOption === 'one-time' ? this.totalNewPriceOneTime : this.totalNewPriceSubscribe;
        return totalPriceWithDiscount;
      },

      get subscribeAndSaveDiscount() {
        const originalPrice = Object.values(this.bundle).reduce((acc, item) => acc + item.originalPrice * item.qty, 0)
        const discountTier = this.getdiscountTier();
        const variantPriceTierDiscount = this.totalPrice * (1 - discountTier / 100)
        const totalPriceWithDiscount = this.calculateSubscriptionPriceRaw(variantPriceTierDiscount);
        const discount = originalPrice - totalPriceWithDiscount;
        const discountPercentage = Math.round((discount / originalPrice) * 100);
        return discountPercentage + '%';
      },

      get bundleCount() {
        return Object.keys(this.bundle).length;
      },

      get qtyForSelected() {
        const productId = this.idTail(this.$el.closest('[data-product]').dataset.productId);

        const products = Object.values(this.bundle).filter(item => item.pid === productId);
        return products.reduce((acc, item) => acc + item.qty, 0);
      },

      calculateSubscriptionPriceRaw(price) {
        let plan = null;
        if (this.sellingPlan === '') {
          plan = this.sellingPlans[0]
        } else {
          plan = this.sellingPlans.find(plan => plan.id === this.sellingPlan);
        }

        if (!plan) return;

        let adjustment = 0;

        if (!plan.priceAdjustmentType) return;

        if (plan.priceAdjustmentType === 'PERCENTAGE') {
          adjustment = plan.priceAdjustmentAmount / 100;
        } else if (plan.priceAdjustmentType === 'FIXED_AMOUNT') {
          adjustment = Number(plan.priceAdjustmentAmount) / 100;
        }

        const subPrice = plan.priceAdjustmentType === 'PERCENTAGE'
            ? price * (1 - adjustment)
            : price - adjustment;

        return subPrice;
      },

      changeVariant(productId, event) {
        const selectedVariantId = event.target.dataset.variantId;
        const selectedVariant = this.findVariantById(productId, selectedVariantId);
        const productCard = event.target.closest('[data-product]');
        const product = this.findProductById(productId);

        productCard.querySelector('[data-variant-id]').value = selectedVariantId;
        productCard.querySelector('[data-image]').src = selectedVariant?.imageSrc ? selectedVariant?.imageSrc : product?.productImageSrc;
        productCard.querySelector('[data-price]').innerHTML = this.formatMoney(this.getVariantPrice(selectedVariant?.price));
        productCard.querySelector('[data-add-to-bundle]').setAttribute('data-selected-variant-id', selectedVariantId);
        productCard.querySelector('[data-variant-title]').innerHTML = selectedVariant.productVariantTitle;
        productCard.querySelector('[data-flavor]').setAttribute('data-flavor', selectedVariant.productVariantTitle.split(' / ')[0]);
        productCard.dataset.selectedVariantId = String(selectedVariantId);
        this.bundle = { ...this.bundle };


        this.selectedVariantId = selectedVariantId;
        this.open = false;
      },

      calculateSubscriptionPrice(price) {
        let plan = null;
        if (this.sellingPlan === '') {
          plan = this.sellingPlans[0]
        } else {
          plan = this.sellingPlans.find(plan => plan.id === this.sellingPlan);
        }

        if (!plan) return;

        let adjustment = 0;

        if (!plan.priceAdjustmentType) return;

        if (plan.priceAdjustmentType === 'PERCENTAGE') {
          adjustment = plan.priceAdjustmentAmount / 100;
        } else if (plan.priceAdjustmentType === 'FIXED_AMOUNT') {
          adjustment = Number(plan.priceAdjustmentAmount) / 100;
        }

        const subPrice = plan.priceAdjustmentType === 'PERCENTAGE'
            ? price * (1 - adjustment)
            : price - adjustment;

        return this.formatMoney(subPrice);
      },
      
      /* ---------- helpers ---------- */
      pid(p) { return String(p); },
      firstVid(p) { return String(p.productVariants?.[0]?.platformId ?? ''); },

      selectCollection(collection) {
          this.activeCollection = collection;

          const bundle = document.querySelector('[data-bundle]');

          if (bundle) {
            const y = bundle.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          }
      },

      setVariant(event,productId) {
        const selectedVariantId = event.target.value;
        const selectedVariant = this.findVariantById(productId, selectedVariantId);
        const productCard = event.target.closest('[data-product]');
        const product = this.findProductById(productId);

        productCard.querySelector('[data-variant-id]').value = selectedVariantId;
        productCard.querySelector('[data-image]').src = selectedVariant?.imageSrc ? selectedVariant?.imageSrc : product?.productImageSrc;
        productCard.querySelector('[data-price]').innerHTML = this.formatMoney(this.getVariantPrice(selectedVariant?.price ?? 0));
        productCard.querySelector('[data-add-to-bundle]').setAttribute('data-selected-variant-id', selectedVariantId);
        productCard.querySelector('[data-flavor]').setAttribute('data-flavor', selectedVariant.productVariantTitle.split(' / ')[0]);
        productCard.dataset.selectedVariantId = selectedVariantId;
        this.bundle = { ...this.bundle };
      },

      getVariantPrice(price) {
        const discount = this.discountTier / 100;
        if (this.purchaseOption === 'one-time') {
          const variantPrice = price * (1 - discount)
          return variantPrice;
        } else {
          const variantPrice = this.calculateSubscriptionPrice(price * (1 - discount))
          return variantPrice;
        }
      },

      findProductById(productId) {
        return this.boxData?.selectableProductVariants?.find(p => this.idTail(p.productPlatformId) === String(productId));
      },

      findVariantById(productId, variantId) {
        const product = this?.findProductById(productId);
        return product?.productVariants?.find(v => this.idTail(v.platformId) === String(variantId));
      },

      selectedVid(p) {
        const pid = String(p);
        return this.selectedByPid[pid] ?? this.firstVid(p);
      },

      // qtyForSelected(pid) {
      //   const productId = String(pid);
      //   const product = Object.values(this.bundle).find(item => item.pid === productId);
      //   return product?.qty || 0;
      // },

      priceForSelected(p) {
        const vid = this.selectedVid(p);
        const v = (p.productVariants || []).find(x => String(x.platformId) === String(vid));
        return v?.price ?? 0; 
      },

      formatMoney(value, fmt = window.Shopify?.money_format || "{{amount}}") {

        const toCents = (v) => {
          if (typeof v === 'number') return Math.round(v * 100);
          if (typeof v === 'string') {
            const cleaned = v.trim().replace(/[,$\s]/g, '');
            const n = Number(cleaned);
            return Number.isFinite(n) ? Math.round(n * 100) : 0;
          }
          return 0;
        };

        const cents = toCents(value);

        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, fmt);
        }

        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const token = (fmt.match(placeholderRegex) || [, 'amount'])[1];

        const withDelims = (n, precision = 2, thousands = ',', decimal = '.') => {
          if (n == null || isNaN(n)) return '0';
          const s = (n / 100).toFixed(precision);
          const [intPart, frac] = s.split('.');
          const intWithSep = intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
          return precision ? `${intWithSep}${decimal}${frac}` : intWithSep;
        };

        let rendered;
        switch (token) {
          case 'amount':
            rendered = withDelims(cents, 2);
            break;
          case 'amount_no_decimals':
            rendered = withDelims(cents, 0);
            break;
          case 'amount_with_comma_separator':
            rendered = withDelims(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            rendered = withDelims(cents, 0, '.', ',');
            break;
          default:
            rendered = withDelims(cents, 2);
        }

        return fmt.replace(placeholderRegex, rendered);
      },

      purchaseOptionChange(e) {
        this.purchaseOption = e.target.value;
        this.setButtonText();
      },

      frequencyChange(e) {
        this.sellingPlan = e.target.dataset.value;
        this.sellingPlanName = e.target.dataset.name;
        this.setButtonText();
        this.open = false;
      },

      addSelected(p,e) {
        const selectedVariantId = e.target.dataset.selectedVariantId;
        const product = this.findProductById(p);
        const variant = this.findVariantById(p,selectedVariantId);
        const vid = selectedVariantId;
        if (!vid) return;
        this.bundle[vid] = { bundleIndex: this.bundleCount, qty: 1, pid: String(p), variantId: selectedVariantId, variant: variant, product: product, originalPrice: variant.price, originalPriceFormatted: this.formatMoney(variant.price) };
        this.totalSelectedQty++;
        this.setButtonText();
      },

      incSelected() {
        const vid = this.idTail(this.$el.closest('[data-product]').dataset.selectedVariantId);
        if (!vid || !this.bundle[vid]) return;
        this.bundle[vid].qty += 1;
        this.totalSelectedQty += 1;
        this.bundle = { ...this.bundle };
        this.setButtonText();
      },
      
      decSelected() {
        const vid = this.idTail(this.$el.closest('[data-product]').dataset.selectedVariantId);
        if (!vid || !this.bundle[vid]) return;
      
        const prev = this.bundle[vid].qty;
        const next = Math.max(0, prev - 1);
        this.totalSelectedQty = Math.max(0, this.totalSelectedQty - 1);
      
        if (next === 0) {
          delete this.bundle[vid];
        } else {
          this.bundle[vid].qty = next;
        }
        this.bundle = { ...this.bundle };
        this.setButtonText();
      },
      
      setQtySelected(q) {
        const vid = this.idTail(this.$el.closest('[data-product]').dataset.selectedVariantId);
        const n = Math.max(0, Number(q) || 0);
        const curr = this.bundle[vid]?.qty || 0;
      
        if (n === 0) {
          if (this.bundle[vid]) {
            this.totalSelectedQty = Math.max(0, this.totalSelectedQty - curr);
            delete this.bundle[vid];
            this.bundle = { ...this.bundle };
          }
          return;
        }
      
        if (!this.bundle[vid]) return; // or create it if that’s desired
        this.totalSelectedQty = Math.max(0, this.totalSelectedQty - curr + n);
        this.bundle[vid].qty = n;
        this.bundle = { ...this.bundle };
        this.setButtonText();
      },   

  
      init() {
        this.jsLoaded = true;
        this.loadBox();
        this.selectCollection(this.activeCollection);

        const bundleDrawer = document.querySelector('[data-bundle-drawer]');

        this.bundleClickOutside = (e) => {
          const path = e.composedPath ? e.composedPath() : [];
          const clickedInside = path.includes(bundleDrawer);
          
          if (this.bundleOpen && !clickedInside) {
            this.bundleOpen = false;
            document.body.style.overflow = 'auto';
          } 
        }

        this.setBundleOpen();


        window.addEventListener('resize', () => {
          this.setBundleOpen();
        });

        this.setButtonText();
      },

      toggle() {
        if (this.open) {
          setTimeout(() => {
            return this.close()
          }, 100);
        }
  
        this.$refs.button.focus()
  
        this.open = true
      },
  
      close(focusAfter) {
        if (! this.open) return
  
        setTimeout(() => {
          this.open = false
        }, 100);
  
        focusAfter && focusAfter.focus()
      },
  
      onKeyDown(event) {
        const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
        const current = event.currentTarget;
        const index = options.indexOf(current);
        const next = options[index + 1] || options[0]; // wrap to first
        next.focus();
        },
        
      onKeyUp(event) {
        const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
        const current = event.currentTarget;
        const index = options.indexOf(current);
        const prev = options[index - 1] || options[options.length - 1]; // wrap to last
        prev.focus();
        },
  
      openAndFocusOption() {
        if (!this.open) {
          this.open = true;
        }
        
        this.$nextTick(() => {
          const selected =
          this.$refs.panel.querySelector('[aria-selected="true"]') ||
          this.$refs.panel.querySelector('[role="option"]');
        
          if (selected) {
          selected.focus();
          }
        });
      },

      setBundleOpen() {
        const isDesktop = window.innerWidth > 1024;
      
        this.bundleOpen = isDesktop;
      
        document.removeEventListener('click', this.bundleClickOutside);
        if (!isDesktop) {
          document.addEventListener('click', this.bundleClickOutside);
        }
      
        document.body.style.overflow = (!isDesktop && this.bundleOpen) ? 'hidden' : 'auto';
      },

      async loadBox() {
        this.loading = true;
        this.error = null;
  
        try {
          const productPlatformId = '9918606475584';

          const res = await fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "*/*",
            },
            body: JSON.stringify({productPlatformId}),
          });
  
          if (!res.ok) throw new Error(`Request failed (${res.status})`);
          const data = await res.json();

          this.boxData = data.DynamicBox;
          this.products = this.boxData.selectableProductVariants;
          const selectable = this.boxData.selectableProductVariants || [];
          const groups = this.boxData.settings?.productGrouping || {};
          const groupOrder = this.boxData.settings?.productGroupingOrder || [];

          const normalizeId = (id) => String(id).split('/').pop().trim();

          const byProductId = new Map();
          const byVariantId = new Map();

          for (const p of selectable) {
            const pid = normalizeId(p.productPlatformId ?? p.productId ?? p.id ?? p.product?.id ?? '');
            if (pid) byProductId.set(pid, p);

            (p.productVariants || []).forEach(v => {
              const vid = normalizeId(v.platformId ?? v.id ?? '');
              if (vid) byVariantId.set(vid, p);
            });
          }

          const orderedNames = (Array.isArray(groupOrder) && groupOrder.length)
            ? groupOrder.map(o => typeof o === 'string' ? o : o?.name).filter(Boolean)
            : Object.keys(groups);

          this.steps = orderedNames.map(name => {
            const ids = groups[name] || [];
            const seen = new Set();
            const products = [];

            ids.forEach(rawId => {
              const id = normalizeId(rawId);
              const prod = byProductId.get(id) || byVariantId.get(id);
              if (!prod) return;

              const key = normalizeId(prod.productPlatformId ?? prod.productId ?? prod.id);
              if (!seen.has(key)) { seen.add(key); products.push(prod); }
            });

            return { name, products };
          });

          for (const step of this.steps) {
            for (const product of step.products) {
              const first = product.productVariants?.[0];
              product.selectedVariant = normalizeId(first?.platformId || '');
              product.selectedVariantPrice = this.products.find(p => this.idTail(p.productPlatformId) === this.idTail(product.productPlatformId))?.productVariants.find(v => this.idTail(v.platformId) === product.selectedVariant)?.price;
              (product.productVariants || []).forEach((v, i) => v.selected = i === 0);
            }
          }

          this.setSellingPlans();

          this.minQty = this.boxData?.sizeRange[0]
          this.maxQty = this.boxData?.sizeRange[1]

          this.discountTiers = this.boxData?.percentDiscountTier || [];

          this.setupProgressBar()

        } catch (err) {
          console.error(err);
          this.error = "Could not load bundle data."+err;
        } finally {
          this.loading = false;
          this.loaded = true;
        }
      },

      setupProgressBar() {
        for (let i = 0; i < this.maxQty; i++) {
          this.placeHolders.push({
            qty: i,
            step: this.steps[0],
            index: i,
          });
        }
      },

      idTail(gid) {
        return String(gid).split('/').pop();
      },

      setSellingPlans() {
        const group = this.boxData.sellingPlanGroup || {};

          this.sellingPlans = Object.entries(group)
            .filter(([, sp]) => !sp.title?.includes('3 Weeks'))
            .map(([spGid, sp]) => ({
              id: this.idTail(spGid),
              gid: spGid,
              name: sp.title,
              title: sp.title,
              interval: sp.interval,
              intervalCount: sp.intervalCount,
              priceAdjustmentType: sp.priceAdjustmentType,
              priceAdjustmentAmount: sp.priceAdjustmentAmount,
              position: sp.position ?? 0,
              allMatch: !!sp.allMatch,
              variantMapping: Object.fromEntries(
                Object.entries(sp.variantMapping || {}).map(([vgid, v]) => [this.idTail(vgid), v])
              ),
            }))
            .sort((a, b) => a.position - b.position);

            // this.sellingPlan = this.sellingPlans[0].id;

      },

      setButtonText() {
          const chooseFrequency = this.purchaseOption === 'subscribe' && this.sellingPlan === '';

          if (this.adding) {
            this.buttonText = 'Adding...';
          } else if (this.totalSelectedQty >= 2) {
            this.buttonText = chooseFrequency ? 'SELECT FREQUENCY' : 'ADD TO CART';
          } else if (this.totalSelectedQty === 0) {
            this.buttonText = 'Add two or more products';
          } else if (this.totalSelectedQty === 1) {
            this.buttonText = 'Add at least one more product';
          }

          this.buttonDisabled = chooseFrequency || this.totalSelectedQty < 2 ? true : false;
      },

      removeProductFromBundle(variantId) {
        const key = this.idTail(String(variantId));
        const item = this.bundle[key];
        if (!item) return;                  // nothing to remove
      
        this.totalSelectedQty = Math.max(0, this.totalSelectedQty - (item.qty || 0));
        delete this.bundle[key];
      
        // nudge Alpine reactivity
        this.bundle = { ...this.bundle };
        this.setButtonText();
      },

      toggleBundleDrawer() {
        this.bundleOpen = !this.bundleOpen;
        this.bundleOpen ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';

      },

      clearBundle() {
        this.bundle = {};
        this.totalSelectedQty = 0;
        this.bundle = { ...this.bundle };
        this.setButtonText();
      },

      async getBundleIndex() {
        const res = await fetch('/cart.js');
        const cartData = await res.json();
      
        const indices = cartData.items
          .map(item => Number(item.properties?._dynamicBoxIndex))
          .filter(val => !isNaN(val));
      
        const largestIndex = indices.length > 0 ? Math.max(...indices) : -1;
        const bundleIndex = largestIndex + 1;
      
        return bundleIndex;
      },

      generateUniqueHash(length = 32) {
        const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(length)))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('');
        const timePart = Date.now().toString(16);
        return `${timePart}${randomPart}`;
      },
      
      async addBundleToCart() {
          const sideCart = document.querySelector('side-cart')
          const items = [];
          const bundleSessionId = this.generateUniqueHash();
          this.adding = true;
          

          const bundleIndex = await this.getBundleIndex();

          Object.entries(this.bundle).forEach(([variantId, e]) => {
            const item = {
              id: Number(variantId),
              quantity: Number(e.qty),
              selling_plan: this.purchaseOption === 'one-time' ? null : Number(this.sellingPlan),
              properties: {
                _attribution: 'Skio Dynamic Product Bundle',
                _dynamicBoxIndex: bundleIndex,
                _dynamicBoxId: this.boxData.boxId,
                _bundleSellingPlanId: Number(this.sellingPlan),
                _bundle_session_id: bundleSessionId,
                _is_bundle: true,
              }
            }

            items.push(item);
          });

            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items }),
            });

          document.dispatchEvent(new CustomEvent('bundle:added'));

          this.adding = false;

          sideCart?.renderCart();
          sideCart?.openCart();

          this.clearBundle();
      }
  
    }));
  };